module.exports = __webpack_public_path__ + "img/5.318b196.png";